import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const RejectIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                 viewBox="0 0 512 512">
                <g id="Group_371" transform="translate(1.061 1.061)">
                    <g id="Line_21">
                        <path fill="fill:#707070;" d="M474.599,510.939c-9.193,0-18.34-3.5-25.34-10.5L8.939,60.119c-14-14-14-36.68,0-50.68
			s36.68-14,50.68,0l440.32,440.32c14,14,14,36.68,0,50.68C492.939,507.439,483.793,510.939,474.599,510.939z"/>
                    </g>
                    <g id="Line_22">
                        <path fill="fill:#707070;" d="M34.279,510.939c-9.17,0-18.34-3.5-25.34-10.5c-14-14-14-36.68,0-50.68l440.32-440.32
			c14-14,36.68-14,50.68,0s14,36.68,0,50.68l-440.32,440.32C52.619,507.439,43.449,510.939,34.279,510.939z"/>
                    </g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
            </svg>
        </SvgIcon>
    )
};

export default RejectIcon;